import { Box, Spinner } from "@adfenix/alexandria";
import { useContext } from "react";
import { ReadLayerContext } from "components/ReadLayer/ReadLayerQueryContext";
import { Table } from "components/Datatable";
import { ReadLayer } from "@adfenix/types";
import { CustomerCampaignRow } from "./CustomerCampaignRow";
import { ResetButton } from "components/ReadLayer/ResetButton";

export const OneCustomerCampaignTable = () => {
  const ctx = useContext(ReadLayerContext);
  if (!ctx) return null;
  const campaigns = ctx.data
    ?.documents as ReadLayer.CustomerCampaignSearchModel[];

  return (
    <Box display="flex" flexDirection="column" justifyContent="end">
      <Box pY="m" display="flex" flexDirection="column">
        <Table
          noTableHead
          progressComponent={
            <Box style={{ minHeight: 780 }}>
              <Spinner centered />
            </Box>
          }
          progressPending={!campaigns || !ctx.updateQuery}
          columns={[
            {
              name: "",
              grow: 1,
              cell: (row: ReadLayer.CustomerCampaignSearchModel) => (
                <CustomerCampaignRow campaign={row} />
              )
            }
          ]}
          pagination={false}
          keyField="id"
          data={campaigns}
        />
      </Box>
      <Box display="flex" justifyContent="end">
        <ResetButton text="Show all campaigns" />
      </Box>
    </Box>
  );
};
